export const homeServiceCountries = [
  'FR',
  'UK',
  'BE',
  'DE',
  'AT',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'ES',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'SE',
  'NO',
  'CH',
];
